module.exports = __webpack_public_path__ + "static/media/login-bg-mobile.4b1e0e29.jpg";